import { ButtonComponentConfig } from './button-component-config.interface';

export interface ButtonWrapper extends ButtonComponentConfig {
    isVisible?: boolean;
}
